class TabbedContainers extends HTMLElement {
  connectedCallback() {
    const nav = this.querySelector('.tabbed-sections__nav');
    const panels = this.querySelectorAll('.tabbed-sections__panel');

    if (!nav || !panels.length) return;

    panels.forEach((panel) => {
      const btn = document.createElement('button');
      btn.className = 'tabbed-sections__btn';
      btn.dataset.tabTarget = panel.id;
      btn.dataset.active = 'false';
      btn.textContent = panel.dataset.tabHeading || 'Tab';
      btn.addEventListener('click', () => this.activate(panel.id));
      nav.appendChild(btn);
    });

    this.activate(panels[0].id);
  }

  activate(targetId) {
    this.querySelectorAll('.tabbed-sections__panel').forEach((panel) => {
      panel.style.display = panel.id === targetId ? '' : 'none';
    });
    this.querySelectorAll('.tabbed-sections__btn').forEach((btn) => {
      btn.dataset.active = btn.dataset.tabTarget === targetId ? 'true' : 'false';
    });
  }
}

customElements.define('tabbed-containers', TabbedContainers);
